<template>
  <div>
    <banner />
    <div class="d-inline-block" style="width: 50%; font-size: 1rem !important">
        To get more information about CRT Hub, access to advanced features or to schedule a tour of the site, please contact us at 
        <a href = "mailto: info@chasenenterprises.com">info@chasenenterprises.com</a>.
    </div>
    <HomePageFooter />
  </div>
</template>
<script>
import Banner from './Banner';
import HomePageFooter from './HomePageFooter';
import LandingRegister from '../LandingRegister';

export default {
  computed: {
    isAuthenticated() {
      return this.$store.getters.authenticated;
    }
  },
  components: {
    Banner,
    HomePageFooter,
    LandingRegister
  }
}
</script>